import { lazy } from "react";
import lazyLoad from "routers/utils/lazyLoad";
import LayoutIndex from "layout/mainLayout";

const singupRouter = [
  {
    element: <LayoutIndex />,
    children: [
      {
        path: "/singup",
        element: lazyLoad(lazy(() => import("view/singup"))),
      },
    ]
  },
];

export default singupRouter;
